import api from './api';

const accountsPayableService = {
  // Listar parcelas pendentes
  getPendingInstallments: async (params = {}) => {
    try {
      const response = await api.get('/accounts-payable/installments', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar parcelas:', error);
      throw error;
    }
  },

  // Obter detalhes de uma parcela
  getInstallmentDetails: async (installmentId) => {
    try {
      const response = await api.get(`/accounts-payable/installments/${installmentId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar detalhes da parcela:', error);
      throw error;
    }
  },

  // Baixar/registrar pagamento de parcela
  payInstallment: async (installmentId, data) => {
    try {
      const response = await api.post(`/accounts-payable/installments/${installmentId}/pay`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao registrar pagamento:', error);
      throw error;
    }
  },

  // Estornar pagamento de parcela
  revertPayment: async (installmentId, reason) => {
    try {
      const response = await api.post(`/accounts-payable/installments/${installmentId}/revert`, { reason });
      return response.data;
    } catch (error) {
      console.error('Erro ao estornar pagamento:', error);
      throw error;
    }
  },

  // Obter parcelas de uma OC específica
  getInstallmentsByOrder: async (orderId) => {
    try {
      const response = await api.get(`/purchase-orders/${orderId}/installments`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar parcelas da OC:', error);
      throw error;
    }
  }
};

export default accountsPayableService;